import styled, { css } from 'styled-components';
import { useOrderAmountRankChart } from '../provider/OrderAmountRankChartProvider';
import { InequalityLeftBlue } from '../../../@icons/svg/InequalityLeftBlue';
import { InequalityLeftBlueDouble } from '../../../@icons/svg/InequalityLeftBlueDouble';
import { InequalityRightBlue } from '../../../@icons/svg/InequalityRightBlue';
import { InequalityRightBlueDouble } from '../../../@icons/svg/InequalityRightBlueDouble';
import { ChartContextType } from '../provider/chartContextType';

export const ChartController = ({
  contextCall,
  title,
}: {
  contextCall: () => ChartContextType;
  title: string;
}) => {
  const {
    setFilterCriteria,
    totalDataLength,
    itemsPerPage,
    startDt,
    endDt,
    totalPage,
    pageIndex,
  } = contextCall();

  const canGetPrevious = pageIndex > 1;

  const canGetNext = pageIndex < totalPage;

  return (
    <Container>
      <TitleArea>
        <h3 style={{ margin: 0 }}>{title}</h3>
        <SubTitle>
          {startDt} ~ {endDt}
        </SubTitle>
      </TitleArea>
      <PeriodContainer>
        <SvgHolder
          $disactive={!canGetPrevious}
          onClick={() => canGetPrevious && setFilterCriteria(1)}
        >
          <InequalityLeftBlueDouble />
        </SvgHolder>
        <SvgHolder
          $disactive={!canGetPrevious}
          onClick={() => canGetPrevious && setFilterCriteria(pageIndex - 1)}
        >
          <InequalityLeftBlue />
        </SvgHolder>
        <PeriodText>
          {totalPage}페이지 중 {pageIndex}페이지
        </PeriodText>
        <SvgHolder
          $disactive={!canGetNext}
          onClick={() => canGetNext && setFilterCriteria(pageIndex + 1)}
        >
          <InequalityRightBlue />
        </SvgHolder>
        <SvgHolder
          $disactive={!canGetNext}
          onClick={() => canGetNext && setFilterCriteria(totalPage)}
        >
          <InequalityRightBlueDouble />
        </SvgHolder>
      </PeriodContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  margin-bottom: 13px;
`;

const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #b3b1b1;
`;

const PeriodContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  /* svg {
    &:hover path {
      cursor: pointer;
      stroke: #4fadff; 
    }
  } */
`;

const SvgHolder = styled.div<{ $disactive?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ $disactive }) =>
    $disactive
      ? css`
          svg {
            path {
              stroke: #8a8a8a;
            }
          }
        `
      : css`
          svg {
            &:hover path {
              cursor: pointer;
              stroke: #4fadff;
            }
          }
        `};
`;

const PeriodText = styled.div`
  font-size: 14px;
  font-weight: 700;
  margin: 0px 10px;
`;
